import React, { useState, useEffect, useRef } from 'react';

// Login: a la izquierda el panel de marca (réplica del Dashboard real en escritorio + celular con
// Conversaciones), a la derecha el formulario. En celular solo se ve el formulario.
// Logos de canales: oficiales (WhatsApp/Messenger de Simple Icons como la landing; Instagram el de Settings.js).
// Cifras y nombres del panel = datos de ejemplo (el login no puede mostrar datos reales).

const CH_SVG = {
  "whatsapp": "<svg viewBox=\"0 0 24 24\" fill=\"#25D366\"><path d=\"M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z\" /></svg>",
  "instagram": "<svg viewBox=\"0 0 24 24\"><defs><linearGradient id=\"ig_real\" x1=\"0\" y1=\"24\" x2=\"24\" y2=\"0\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#FFD600\"/><stop offset=\"0.45\" stop-color=\"#FF0069\"/><stop offset=\"1\" stop-color=\"#7638FA\"/></linearGradient></defs><path fill=\"url(#ig_real)\" d=\"M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077\"/></svg>",
  "messenger": "<svg viewBox=\"0 0 24 24\" fill=\"#0084FF\"><path d=\"M12 0C5.37 0 0 4.97 0 11.11c0 3.5 1.74 6.62 4.47 8.66V24l4.09-2.24c1.09.3 2.24.46 3.44.46 6.63 0 12-4.97 12-11.11S18.63 0 12 0zm1.19 14.96l-3.06-3.26-5.97 3.26 6.57-6.98 3.13 3.26 5.9-3.26-6.57 6.98z\" /></svg>"
};

const PHONE_POOL = [
  ['María Gómez', '¿Me llega a Pereira?', 'whatsapp', 2],
  ['Andrés Pérez', 'Quiero la talla 40', 'instagram', 1],
  ['Camila Ríos', '¡Gracias, ya llegó! 🙌', 'whatsapp', 0],
  ['Juan Torres', '¿Aceptan ADDI?', 'messenger', 1],
  ['Sara Méndez', '¿Cuánto vale el envío?', 'whatsapp', 3],
  ['Luis Peña', 'Confirmo contra entrega', 'instagram', 0],
];

const NAV = [
  ['Dashboard', <><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></>],
  ['Conversaciones', <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>],
  ['Pedidos', <><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></>],
  ['Contactos', <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></>],
  ['Marketing', <><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></>],
  ['Campañas', <><path d="M22 2L11 13"/><path d="M22 2L15 22L11 13L2 9L22 2Z"/></>],
];
const Ico = ({ children }) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">{children}</svg>;

const WEEK = [[38, 30, 'Lun'], [52, 41, 'Mar'], [47, 44, 'Mié'], [61, 50, 'Jue'], [58, 49, 'Vie'], [72, 55, 'Sáb'], [66, 48, 'Dom']];
const BOARD = [
  ['Nuevas', 'últimas 24 h', 58, [['María Gómez', '¿Me llega a Pereira?', '10:42', 2], ['Andrés Pérez', 'Quiero la talla 40', '10:31', 1]]],
  ['Atendidas por el bot', 'activas 24 h', 41, [['Camila Ríos', '¿Tienen en color blanco?', '10:20', 0], ['Juan Torres', '¿Aceptan ADDI?', '09:58', 1]]],
  ['Escaladas a asesor', 'pendientes', 3, [['Sara Méndez', 'Necesito cambiar la dirección de envío', '10:05', 3, true], ['Luis Peña', 'Mi pedido no ha llegado', '09:40', 1]]],
  ['Venta cerrada', 'por el bot · 30 días', 12, [['Diana Castro', 'Perfecto, confirmo contra entrega', 'Ayer', 0], ['Felipe Ruiz', 'Listo, pago con Wompi', 'Ayer', 0]]],
];

export const TalkuSymbol = ({ color = '#111', size = 28, animated = true }) => (
  <svg className={animated ? 'sym' : undefined} viewBox="0 0 256 256" width={size} height={size} aria-hidden="true">
    {animated ? <>
      <path className="a sm" d="M38 128 A90 90 0 0 0 201.7 179.6" pathLength="1" stroke={color}/>
      <g className="bg"><path className="a br" d="M158.8 43.4 A90 90 0 0 1 198.9 72.6" pathLength="1" stroke={color}/></g>
      <circle className="dt" cx="83" cy="55" r="31"/>
    </> : <>
      <path d="M38 128 A90 90 0 0 0 201.7 179.6" fill="none" stroke={color} strokeWidth="44"/>
      <path d="M158.8 43.4 A90 90 0 0 1 198.9 72.6" fill="none" stroke={color} strokeWidth="44"/>
      <circle cx="83" cy="55" r="31" fill="#88DA21"/>
    </>}
  </svg>
);

// Cifra que cuenta desde 0
function CountUp({ to, money, suffix = '', delay = 900 }) {
  const [v, setV] = useState(0);
  useEffect(() => {
    let raf = 0;
    const t = setTimeout(() => {
      const t0 = performance.now();
      const step = (now) => { const k = Math.min(1, (now - t0) / 1300); setV(to * (1 - Math.pow(1 - k, 3))); if (k < 1) raf = requestAnimationFrame(step); };
      raf = requestAnimationFrame(step);
    }, delay);
    return () => { clearTimeout(t); cancelAnimationFrame(raf); };
  }, [to, delay]);
  return <>{money ? '$' + Math.round(v).toLocaleString('es-CO') : Math.round(v) + suffix}</>;
}

function DashboardReplica() {
  const boxRef = useRef(null);
  useEffect(() => {
    const el = boxRef.current;
    if (!el) return undefined;
    const fit = () => el.style.setProperty('--k', (el.clientWidth / 1280).toFixed(4));
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, []);
  const N = 40, R = 92, r = 70, cx = 110, cy = 104, on = Math.round(0.78 * N);
  const arrow = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;
  const cal = <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="5" width="18" height="16" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="3" x2="8" y2="7"/><line x1="16" y1="3" x2="16" y2="7"/></svg>;
  return (
    <div className="desk" ref={boxRef}>
      <div className="r-scale">
        <div className="r-top">
          <div className="r-brand"><span className="r-logo"><TalkuSymbol size={18} animated={false}/></span><b>Talku</b><span className="r-bs"/><span className="r-crm">CRM</span></div>
          <nav className="r-nav">
            {NAV.map(([n, d]) => <span key={n} className={`r-ni${n === 'Dashboard' ? ' on' : ''}`}><Ico>{d}</Ico>{n}</span>)}
            <span className="r-sep"/>
            <span className="r-ni"><Ico><circle cx="12" cy="12" r="3"/><path d="M12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/></Ico>Configuraciones</span>
          </nav>
          <div className="r-right">
            <span className="r-tb"><Ico><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></Ico><em>4</em></span>
            <span className="r-tb"><Ico><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></Ico></span>
            <span className="r-prof"><span className="r-av">LM</span><span><b>Laura</b><small>Administrador</small></span></span>
          </div>
        </div>
        <div className="r-body">
          <h1 className="r-greet">Buenos días, Laura</h1>
          <p className="r-sub">Hoy: 342 mensajes · 58 conversaciones nuevas · 12 ventas del bot</p>
          <div className="r-hero">
            <div>
              <h3 className="r-ht">Mensajes recibidos</h3>
              <div className="r-wb-wrap">
                <div className="r-wy"><span>80</span><span>40</span><span>0</span></div>
                <div className="r-wcols">
                  {WEEK.map(([c, p, d], i) => (
                    <div className="r-wcol" key={d}>
                      <div className="r-wpair">
                        <span className="r-wb solid" style={{ '--h': `${(c / 80) * 100}%`, '--d': `${i * 60}ms` }}/>
                        <span className="r-wb hatch" style={{ '--h': `${(p / 80) * 100}%`, '--d': `${i * 60 + 30}ms` }}/>
                      </div>
                      <span className="r-wl">{d}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="r-leg"><span><i style={{ background: '#0a0a0a' }}/>Esta semana</span><span><i className="hatchi"/>Semana anterior</span></div>
            </div>
            <div className="r-gauge">
              <svg viewBox="0 0 220 112">
                {Array.from({ length: N + 1 }).map((_, i) => {
                  const a = Math.PI - (i / N) * Math.PI;
                  return <line key={i} x1={cx + r * Math.cos(a)} y1={cy - r * Math.sin(a)} x2={cx + R * Math.cos(a)} y2={cy - R * Math.sin(a)}
                    stroke="#0a0a0a" strokeWidth="2.4" strokeLinecap="round" className={i <= on ? 't-on' : 't-off'} style={{ '--d': `${900 + i * 25}ms` }}/>;
                })}
              </svg>
              <div className="r-gv"><b><CountUp to={78} suffix="%"/></b><span>Respondido por el bot · 30 días</span></div>
            </div>
            <div className="r-big">
              <div className="r-bn"><CountUp to={87}/></div>
              <div className="r-br"><span>Conversaciones<br/>activas · 24 h</span><span className="r-arr">{arrow}</span></div>
            </div>
            <div className="r-big">
              <div className="r-bn"><CountUp to={2480000} money/></div>
              <div className="r-br"><span>Ventas del bot hoy<br/><b className="r-trend">12 pedidos · +18% vs ayer</b></span><span className="r-arr">{arrow}</span></div>
            </div>
          </div>
          <div className="r-board">
            {BOARD.map(([t, n, c, items], ci) => (
              <div className="r-col" key={t} style={{ '--d': `${700 + ci * 90}ms` }}>
                <div className="r-colh"><div><div className="r-colt">{t}</div><div className="r-coln">{n}</div></div><span className="r-cnt">{c}</span></div>
                {items.map(([a, b, tm, u, dk]) => (
                  <div className={`r-tk${dk ? ' dark' : ''}`} key={a}>
                    <div className="r-tkn">{a}</div>
                    <div className="r-tkp">{b}</div>
                    <div className="r-tkf"><span className="r-chip">{cal}{tm}</span>{u > 0 && <span className="r-un">{u}</span>}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const ChLogo = ({ ch, style }) => <span className="av ch" style={style} dangerouslySetInnerHTML={{ __html: CH_SVG[ch] }}/>;

function PhoneConversations() {
  const [items, setItems] = useState(() => [1, 2, 3, 4, 5, 0].map((p, i) => ({ key: `s${i}`, c: PHONE_POOL[p], time: `${10 - i}:${40 - i * 7}`, fresh: false })));
  const [toast, setToast] = useState(null);
  useEffect(() => {
    let alive = true, idx = 0;
    const timers = new Set();
    const wait = (ms) => new Promise(res => { const t = setTimeout(() => { timers.delete(t); res(); }, ms); timers.add(t); });
    (async () => {
      await wait(1800);
      while (alive) {
        const c = PHONE_POOL[idx % PHONE_POOL.length];
        setToast(c); await wait(1600); if (!alive) return;
        setToast(null); await wait(300); if (!alive) return;
        const key = `n${idx}`;
        setItems(prev => [{ key, c, time: 'ahora', fresh: true }, ...prev].slice(0, 7));
        const t = setTimeout(() => setItems(prev => prev.map(x => x.key === key ? { ...x, fresh: false } : x)), 2200); timers.add(t);
        idx++; await wait(3200);
      }
    })();
    return () => { alive = false; timers.forEach(clearTimeout); };
  }, []);
  return (
    <div className="phone">
      <div className="p-scr">
        <span className="p-isl"/>
        <div className="p-bar"><span>9:41</span><span>●●● 5G</span></div>
        <div className={`p-toast${toast ? ' on' : ''}`}>
          {toast && <><ChLogo ch={toast[2]} style={{ width: 24, height: 24 }}/><div><b>{toast[0]}</b><span>{toast[1]}</span></div></>}
        </div>
        <div className="p-h"><b>Conversaciones</b><span>+ Nuevo</span></div>
        <div className="p-search">Buscar conversación</div>
        <div className="p-tabs"><span className="on">Todos</span><span>No leídos</span><span>Míos</span></div>
        <div className="p-list">
          {items.map(it => (
            <div key={it.key} className={`ci${it.fresh ? ' new new-in' : ''}`}>
              <ChLogo ch={it.c[2]}/>
              <div className="ci-b">
                <div className="ci-t"><b>{it.c[0]}</b><time>{it.time}</time></div>
                <div className="ci-p"><span>{it.c[1]}</span>{it.c[3] > 0 && <em>{it.c[3]}</em>}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Envoltorio compartido por Login y Register: panel de marca + columna del formulario
export function AuthShell({ children }) {
  return (
    <div className="lg-root">
      <style>{`
/* Layout: panel de marca a la izquierda (titular + Dashboard de escritorio + celular con Conversaciones), formulario centrado a la derecha. Un solo tema claro, como el panel. */
.lg-root{
  --ink:#111111; --muted:#6B7280; --soft:#9CA3AF; --line:#EFEFEF; --app:#F5F5F3;
  --panel:#0B0B0B; --lime:#88DA21;
  --font:'SF Pro Display','SF Pro Text',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
  --ease:cubic-bezier(.16,1,.3,1);
}


.lg-root{background:#fff;color:var(--ink);font-family:var(--font);-webkit-font-smoothing:antialiased;min-height:100vh}
.lg-root *,.lg-root *::before,.lg-root *::after{box-sizing:border-box;margin:0;padding:0}
.lk{display:flex;min-height:100vh;padding:14px;gap:14px}

/* ── Panel de marca ── */
.brand{flex:1.08;min-width:0;position:relative;overflow:hidden;border-radius:10px;background:var(--panel);color:#fff;padding:56px 52px 0;display:flex;flex-direction:column;isolation:isolate}
.brand::before{content:'';position:absolute;inset:-20% -10% auto auto;width:70%;height:90%;background:linear-gradient(115deg,rgba(255,255,255,.07),rgba(255,255,255,0) 55%);transform:skewX(-18deg);z-index:-1}
.brand::after{content:'';position:absolute;left:-10%;top:-30%;width:70%;height:70%;background:radial-gradient(circle,rgba(136,218,33,.18),transparent 65%);z-index:-1;animation:drift 16s ease-in-out infinite alternate}
.b-copy{max-width:460px;margin:0 auto;text-align:center;animation:rise .7s var(--ease) both}
.b-tile{width:52px;height:52px;border-radius:10px;margin:0 auto 22px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);display:flex;align-items:center;justify-content:center;box-shadow:0 10px 30px rgba(0,0,0,.35)}
.b-copy h2{font-size:26px;font-weight:500;letter-spacing:-.4px;line-height:1.25;text-wrap:balance}
.b-copy p{font-size:14px;color:rgba(255,255,255,.62);line-height:1.6;margin-top:10px;text-wrap:balance}

.shots{position:relative;flex:1;min-height:340px;margin-top:34px}
/* Escritorio: réplica del Dashboard real (Dashboard.js + barra de Layout.js), diseñada a 1280px y escalada */
.desk{position:absolute;left:21%;top:0;width:640px;height:440px;border-radius:8px 8px 0 0;box-shadow:0 30px 70px rgba(0,0,0,.5);overflow:hidden;background:#fff;animation:up .9s var(--ease) .25s both;color:#0a0a0a}
.r-scale{width:1280px;transform-origin:0 0;transform:scale(var(--k,.5))}
.r-top{height:52px;background:#fff;border-bottom:1px solid #EFEFEF;display:flex;align-items:center;gap:14px;padding:0 20px}
.r-brand{display:flex;align-items:center;gap:9px;padding-right:14px;border-right:1px solid #EFEFEF}
.r-logo{width:28px;height:28px;border-radius:6px;border:1px solid #EFEFEF;display:flex;align-items:center;justify-content:center}
.r-brand b{font-size:14px;font-weight:500}.r-bs{width:1px;height:14px;background:#E5E7EB}.r-crm{font-size:12.5px;color:#9CA3AF}
.r-nav{display:flex;align-items:center;gap:2px}
.r-ni{display:flex;align-items:center;gap:7px;padding:6px 11px;border-radius:6px;font-size:13px;color:#6B7280;position:relative}
.r-ni svg{color:#9CA3AF}
.r-ni.on{background:#F3F3F3;color:#111}.r-ni.on svg{color:#111}
.r-ni.on::after{content:'';position:absolute;left:11px;right:11px;bottom:-10px;height:2px;background:#111;border-radius:1px}
.r-sep{width:1px;height:16px;background:#EFEFEF;margin:0 4px}
.r-right{margin-left:auto;display:flex;align-items:center;gap:6px}
.r-tb{width:32px;height:32px;border-radius:6px;border:1px solid #EFEFEF;display:flex;align-items:center;justify-content:center;color:#6B7280;position:relative}
.r-tb em{position:absolute;top:-6px;right:-7px;min-width:17px;height:17px;border-radius:4px;background:#111;color:#fff;border:2px solid #fff;font-size:10px;font-style:normal;line-height:13px;text-align:center}
.r-prof{display:flex;align-items:center;gap:8px;border:1px solid #EFEFEF;border-radius:6px;padding:3px 9px 3px 3px}
.r-av{width:26px;height:26px;border-radius:50%;background:#F0F0F0;color:#374151;font-size:10px;font-weight:500;display:flex;align-items:center;justify-content:center}
.r-prof b{display:block;font-size:13px;font-weight:400;line-height:1.25}.r-prof small{display:block;font-size:11px;color:#9CA3AF;line-height:1.25}
.r-body{padding:32px 40px}
.r-greet{font-size:28px;font-weight:700;letter-spacing:-.6px}
.r-sub{font-size:13px;color:#6B7280;margin:6px 0 20px}
.r-hero{background:#f6f6f6;border:1px solid #e6e6e6;border-radius:10px;padding:28px 32px;display:grid;grid-template-columns:1.25fr 1fr .7fr .7fr;gap:28px;align-items:center;margin-bottom:28px;animation:rise .5s var(--ease) .55s both}
.r-ht{font-size:14px;font-weight:700;margin:0 0 12px}
.r-wb-wrap{display:flex;gap:10px;height:150px}
.r-wy{display:flex;flex-direction:column;justify-content:space-between;font-size:10.5px;color:rgba(10,10,10,.6);padding-bottom:20px;text-align:right;min-width:22px}
.r-wcols{flex:1;display:flex;gap:10px}
.r-wcol{flex:1;display:flex;flex-direction:column;align-items:center;gap:6px}
.r-wpair{flex:1;width:100%;display:flex;align-items:flex-end;justify-content:center;gap:3px}
.r-wb{width:42%;max-width:16px;border-radius:2px 2px 0 0;height:0;animation:barUp .8s var(--ease) forwards;animation-delay:calc(.9s + var(--d))}
.r-wb.solid{background:#0a0a0a}
.r-wb.hatch,.hatchi{background:repeating-linear-gradient(135deg,#0a0a0a 0 2px,transparent 2px 6px);box-shadow:inset 0 0 0 1.5px #0a0a0a}
.r-wl{font-size:11px;font-weight:600;color:rgba(10,10,10,.7)}
.r-leg{display:flex;gap:14px;font-size:11px;margin-top:8px;color:rgba(10,10,10,.75)}
.r-leg i{display:inline-block;width:10px;height:10px;border-radius:2px;margin-right:5px;vertical-align:-1px}
.r-gauge{position:relative;text-align:center}
.r-gauge svg{width:100%;max-width:260px;display:block;margin:0 auto}
.r-gauge line{stroke-opacity:.18}
.r-gauge line.t-on{animation:tickOn .3s ease forwards;animation-delay:var(--d)}
.r-gv{position:absolute;left:0;right:0;bottom:4px}
.r-gv b{display:block;font-size:34px;font-weight:700;letter-spacing:-1px;line-height:1;font-variant-numeric:tabular-nums}
.r-gv span{font-size:12px;color:rgba(10,10,10,.7)}
.r-big{display:flex;flex-direction:column;gap:22px}
.r-bn{font-size:34px;font-weight:700;letter-spacing:-1px;line-height:1;font-variant-numeric:tabular-nums}
.r-br{display:flex;align-items:flex-end;justify-content:space-between;gap:8px;font-size:12px;line-height:1.35;color:rgba(10,10,10,.75)}
.r-trend{font-size:11.5px;font-weight:600;color:#0a0a0a}
.r-arr{display:inline-flex;padding:4px}
.r-board{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px}
.r-col{animation:rise .5s var(--ease) both;animation-delay:var(--d)}
.r-colh{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px}
.r-colt{font-size:17px;font-weight:700;letter-spacing:-.3px}
.r-coln{font-size:11.5px;color:#6B7280;margin-top:2px}
.r-cnt{font-size:12px;background:#F4F4F4;border-radius:4px;padding:4px 10px}
.r-tk{background:#fff;border:1px solid #E8E8E8;border-radius:8px;padding:14px;margin-bottom:10px}
.r-tk.dark{background:#0a0a0a;color:#fff;border-color:#0a0a0a}
.r-tkn{font-size:14px;font-weight:700;margin-bottom:6px}
.r-tkp{font-size:12px;color:#6B7280;line-height:1.4;min-height:34px}
.r-tk.dark .r-tkp{color:rgba(255,255,255,.7)}
.r-tkf{display:flex;align-items:center;justify-content:space-between;margin-top:12px}
.r-chip{display:inline-flex;align-items:center;gap:5px;font-size:11px;border:1px solid #E8E8E8;border-radius:4px;padding:3px 8px}
.r-tk.dark .r-chip{border-color:rgba(255,255,255,.25)}
.r-un{background:#a3e31c;color:#0a0a0a;border-radius:4px;padding:1px 8px;font-size:11.5px}
@keyframes barUp{to{height:var(--h)}}
@keyframes tickOn{to{stroke-opacity:1}}

/* Celular: Conversaciones */
.phone{position:absolute;left:4%;bottom:-40px;width:228px;height:430px;background:#111;border-radius:34px;padding:9px;box-shadow:0 30px 60px rgba(0,0,0,.55),inset 0 0 0 1px rgba(255,255,255,.12);animation:up .9s var(--ease) .45s both;color:var(--ink)}
.p-scr{width:100%;height:100%;background:#fff;border-radius:26px;overflow:hidden;position:relative}
.p-isl{position:absolute;top:7px;left:50%;transform:translateX(-50%);width:70px;height:20px;background:#111;border-radius:12px;z-index:2}
.p-bar{display:flex;justify-content:space-between;padding:9px 18px 0;font-size:10px;font-weight:500}
.p-h{padding:16px 14px 8px;display:flex;align-items:center;justify-content:space-between}
.p-h b{font-size:15px;font-weight:500}
.p-h span{font-size:10px;color:var(--muted);border:1px solid #E5E7EB;border-radius:4px;padding:2px 6px}
.p-search{margin:0 14px 8px;height:26px;border-radius:6px;background:#F5F5F5;font-size:10px;color:var(--soft);display:flex;align-items:center;padding:0 9px}
.p-tabs{display:flex;gap:4px;padding:0 14px 8px;font-size:9.5px;color:var(--muted)}
.p-tabs span{padding:3px 8px;border-radius:4px}
.p-tabs .on{background:#F3F3F3;color:var(--ink)}
.p-list{position:relative}
.ci{display:flex;gap:9px;align-items:center;padding:8px 14px;border-top:1px solid #F5F5F5;background:#fff;transition:transform .5s var(--ease),opacity .5s,background .6s}
.ci.new{background:#F7FBEF}
.av{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:500;color:#374151;flex-shrink:0;position:relative}
.av i{position:absolute;right:-1px;bottom:-1px;width:8px;height:8px;border-radius:50%;background:#22C55E;border:2px solid #fff}
.ci-b{flex:1;min-width:0}
.ci-t{display:flex;justify-content:space-between;font-size:10.5px}
.ci-t b{font-weight:500}
.ci-t time{font-size:9px;color:var(--soft)}
.ci-p{display:flex;justify-content:space-between;align-items:center;font-size:9.5px;color:var(--muted);margin-top:1px}
.ci-p span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ci-p em{font-style:normal;min-width:15px;height:15px;border-radius:4px;background:#111;color:#fff;font-size:8.5px;display:flex;align-items:center;justify-content:center;padding:0 4px;margin-left:6px}
.p-toast{position:absolute;left:10px;right:10px;top:34px;background:rgba(255,255,255,.96);border:1px solid var(--line);border-radius:8px;box-shadow:0 8px 20px rgba(0,0,0,.12);padding:7px 9px;display:flex;gap:8px;align-items:center;font-size:9.5px;transform:translateY(-140%);opacity:0;transition:transform .5s var(--ease),opacity .4s;z-index:3}
.p-toast.on{transform:none;opacity:1}
.p-toast b{font-weight:500;display:block;font-size:10px}
.p-toast span{color:var(--muted)}

.av.ch{background:#fff;border:1px solid #EFEFEF}
.av.ch svg{width:58%;height:58%;display:block}
/* ── Formulario ── */
.form-side{flex:1;min-width:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 24px;position:relative}
.fbox{width:min(360px,100%);display:flex;flex-direction:column}
.f-logo{width:52px;height:52px;border-radius:10px;margin:0 auto 18px;border:1px solid var(--line);display:flex;align-items:center;justify-content:center;box-shadow:0 8px 24px rgba(17,17,17,.08);animation:rise .6s var(--ease) both}
.f-h{text-align:center;font-size:22px;font-weight:500;letter-spacing:-.3px;animation:rise .6s var(--ease) .06s both}
.f-sub{text-align:center;font-size:13px;color:var(--muted);margin:5px 0 26px;animation:rise .6s var(--ease) .12s both}
.lbl{font-size:12px;color:var(--ink);margin-bottom:6px;display:block}
.grp{display:flex;flex-direction:column;gap:14px;margin-bottom:12px}
.grp>div{animation:rise .6s var(--ease) both}.grp>div:nth-child(1){animation-delay:.18s}.grp>div:nth-child(2){animation-delay:.24s}
.fld{display:flex;align-items:center;gap:8px;height:42px;padding:0 12px;border:1px solid #E5E7EB;border-radius:6px;background:#fff;transition:border-color .15s,box-shadow .15s}
.fld:focus-within{border-color:var(--ink);box-shadow:0 0 0 3px rgba(17,17,17,.06)}
.fld input{flex:1;min-width:0;border:none;outline:none;background:transparent;font:inherit;font-size:13.5px;color:var(--ink)}
.fld input::placeholder{color:#C4C4C4}
.eye{background:none;border:none;color:var(--soft);cursor:pointer;display:flex;padding:4px;border-radius:4px}
.eye:hover{color:var(--ink)}
.btn{height:42px;border:none;border-radius:6px;background:var(--ink);color:#fff;font:inherit;font-size:14px;font-weight:400;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;margin-top:8px;transition:background .15s,transform .15s;animation:rise .6s var(--ease) .3s both}
.btn:hover{background:#2B2B2B}.btn:active{transform:scale(.985)}
.btn:focus-visible,.lnk:focus-visible{outline:2px solid var(--ink);outline-offset:2px}
.spin{width:14px;height:14px;border:2px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:spinA .7s linear infinite;display:none}
.btn.loading .spin{display:block}
.alt{text-align:center;font-size:13px;color:var(--muted);margin-top:22px;animation:rise .6s var(--ease) .36s both}
.lnk{color:var(--ink);text-decoration:none;border-bottom:1px solid #D1D5DB}
.lnk:hover{border-color:var(--ink)}
.foot{position:absolute;bottom:18px;left:0;right:0;display:flex;justify-content:center;gap:14px;font-size:11.5px;color:var(--soft)}
.foot a{color:inherit;text-decoration:none}.foot a:hover{color:var(--ink)}

/* Símbolo de Talku animado */
.sym{overflow:visible}
.sym .a{fill:none;stroke-width:44;stroke-dasharray:1;stroke-dashoffset:1}
.sym .sm{animation:draw .7s cubic-bezier(.65,0,.35,1) .15s forwards}
.sym .br{animation:draw .3s cubic-bezier(.65,0,.35,1) .75s forwards}
.sym .bg{transform-origin:128px 128px;transform-box:view-box;animation:wink 4s ease-in-out 1.7s infinite}
.sym .dt{fill:var(--lime);transform-origin:83px 55px;transform-box:view-box;transform:scale(0);animation:pop .5s cubic-bezier(.34,1.56,.64,1) 1s forwards,bob 4s ease-in-out 1.9s infinite}

@keyframes rise{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
@keyframes up{from{opacity:0;transform:translateY(60px)}to{opacity:1;transform:none}}
@keyframes fade{to{opacity:1}}
@keyframes draw{to{stroke-dashoffset:0}}
@keyframes grow{to{width:var(--w)}}
@keyframes pop{from{transform:scale(0)}to{transform:scale(1)}}
@keyframes bob{0%,100%{translate:0 0}45%{translate:0 -9px}60%{translate:0 2px}75%{translate:0 0}}
@keyframes wink{0%,40%,100%{transform:rotate(0)}50%{transform:rotate(14deg)}62%{transform:rotate(0)}}
@keyframes spinA{to{transform:rotate(360deg)}}
@keyframes drift{from{transform:translate(0,0)}to{transform:translate(80px,60px)}}

/* Celular: solo formulario, con el logo arriba */
@media (max-width:900px){
  .lk{padding:0}
  .brand{display:none}
  .form-side{min-height:100vh;padding:48px 20px 70px}
}
@media (prefers-reduced-motion:reduce){.lg-root *{animation-duration:.01ms!important;animation-iteration-count:1!important;transition-duration:.01ms!important}}

        .lg-forgot{display:flex;justify-content:flex-end;margin:-6px 0 12px;font-size:12.5px}
        .lg-err{font-size:12.5px;color:#B42318;background:#FEF6F6;border:1px solid #F0DADA;border-radius:6px;padding:8px 11px;margin-top:2px;margin-bottom:4px;animation:rise .3s ease both}
        .btn:disabled{cursor:default;background:#2B2B2B}
        .spin{display:block}
        .lnk{background:none;border:none;border-bottom:1px solid #D1D5DB;font:inherit;cursor:pointer;padding:0}
        .new-in{animation:ciIn .5s var(--ease) both}
        @keyframes ciIn{from{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:none}}
      `}</style>

      <div className="lk">
        <section className="brand" aria-hidden="true">
          <div className="b-copy">
            <div className="b-tile"><TalkuSymbol color="#fff"/></div>
            <h2>Tus ventas por chat, de la conversación a la entrega</h2>
            <p>Atiende WhatsApp, Instagram y Messenger, confirma pedidos, genera guías y sigue cada envío desde un solo lugar.</p>
          </div>
          <div className="shots">
            <DashboardReplica/>
            <PhoneConversations/>
          </div>
        </section>

        <main className="form-side">
          {children}
          <div className="foot"><a href="/terminos">Términos</a><a href="/privacidad">Privacidad</a><span>© {new Date().getFullYear()} Talku</span></div>
        </main>
      </div>
    </div>
  );
}

export default function Login({ onLogin, onShowRegister }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [mode, setMode]         = useState('login'); // login | forgot | sent
  const [fEmail, setFEmail]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://talku.online/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('talku_token', data.token);
        onLogin({ id: data.id, email: data.email, name: data.name, role: data.role, token: data.token });
      } else {
        const d = await res.json().catch(() => ({}));
        const msg = typeof d.detail === 'string' ? d.detail : '';
        if (res.status === 403 && msg) setError(msg);
        else if (res.status === 429) setError(msg || 'Demasiados intentos. Espera un minuto e intenta de nuevo.');
        else setError('Correo o contraseña incorrectos');
      }
    } catch {
      setError('Error de conexión. Intenta de nuevo.');
    }
    setLoading(false);
  };

  return (
    <AuthShell>
          {mode !== 'login' ? (
            <form className="fbox" onSubmit={async (e) => {
              e.preventDefault(); setLoading(true); setError('');
              try {
                const r = await fetch('https://talku.online/auth/password/forgot', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: fEmail }) });
                if (r.ok) setMode('sent'); else setError(r.status === 429 ? 'Demasiados intentos. Espera un rato e intenta de nuevo.' : 'No se pudo enviar. Intenta de nuevo.');
              } catch { setError('Error de conexión. Intenta de nuevo.'); }
              setLoading(false);
            }}>
              <div className="f-logo"><TalkuSymbol/></div>
              {mode === 'forgot' ? (<>
                <h1 className="f-h">Recupera tu acceso</h1>
                <p className="f-sub">Te enviamos un enlace para crear una contraseña nueva</p>
                <div className="grp"><div><label className="lbl" htmlFor="lg-femail">Correo</label><div className="fld"><input id="lg-femail" type="email" placeholder="correo@empresa.com" value={fEmail} onChange={e => setFEmail(e.target.value)} required autoComplete="email" autoFocus/></div></div></div>
                {error && <div className="lg-err">{error}</div>}
                <button className="btn" type="submit" disabled={loading}>{loading && <span className="spin"/>}{loading ? 'Enviando…' : 'Enviar enlace'}</button>
              </>) : (<>
                <h1 className="f-h">Revisa tu correo</h1>
                <p className="f-sub">Si <b>{fEmail}</b> tiene una cuenta en Talku, te llegará un enlace para crear tu contraseña nueva. Vence en 30 minutos.</p>
              </>)}
              <p className="alt"><button type="button" className="lnk" onClick={() => { setMode('login'); setError(''); }}>Volver a iniciar sesión</button></p>
            </form>
          ) : (
          <form className="fbox" onSubmit={handleSubmit}>
            <div className="f-logo"><TalkuSymbol/></div>
            <h1 className="f-h">Bienvenido a Talku</h1>
            <p className="f-sub">Ingresa con el correo de tu equipo</p>
            <div className="grp">
              <div>
                <label className="lbl" htmlFor="lg-email">Correo</label>
                <div className="fld"><input id="lg-email" type="email" placeholder="correo@empresa.com" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email"/></div>
              </div>
              <div>
                <label className="lbl" htmlFor="lg-pass">Contraseña</label>
                <div className="fld">
                  <input id="lg-pass" type={showPass ? 'text' : 'password'} placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password"/>
                  <button type="button" className="eye" onClick={() => setShowPass(v => !v)} tabIndex={-1} aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
                    {showPass
                      ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                      : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>}
                  </button>
                </div>
              </div>
            </div>
            <div className="lg-forgot"><button type="button" className="lnk" onClick={() => { setFEmail(email); setError(''); setMode('forgot'); }}>¿Olvidaste tu contraseña?</button></div>
            {error && <div className="lg-err">{error}</div>}
            <button className="btn" type="submit" disabled={loading}>
              {loading && <span className="spin"/>}
              {loading ? 'Ingresando…' : 'Iniciar sesión'}
            </button>
            <p className="alt">¿No tienes cuenta? <button type="button" className="lnk" onClick={onShowRegister}>Crea una</button></p>
          </form>
          )}
    </AuthShell>
  );
}
